// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledTabsList = styled.ul`
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  position: relative;
  top: 1px;
  flex-wrap: wrap;

  li {
    color: #43a5c6;
    cursor: pointer;
  }

  button {
    background: inherit;
    outline: none;
    border: none;
    padding: 6px 30px 5px 30px;
    margin: 0;
  }

  .active {
    background: #ffffff;
    color: #000000;
    border: 1px solid #d9d9d9;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom: 0;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const EventFormNavigation = ({ selectedTab, setSelectedTab }) => (
  <StyledTabsList>
    <li>
      <button
        type='button'
        onClick={() => setSelectedTab('regular')}
        className={`${selectedTab === 'regular' ? 'active' : ''}`}
      >
        Create New
      </button>
    </li>
    <li>
      <button
        type='button'
        onClick={() => setSelectedTab('ideas')}
        className={`${selectedTab === 'ideas' ? 'active' : ''}`}
      >
        Add from ideas
      </button>
    </li>
    <li>
      <button
        type='button'
        onClick={() => setSelectedTab('non-bookable')}
        className={`${selectedTab === 'non-bookable' ? 'active' : ''}`}
      >
        Add from Non-bookable
      </button>
    </li>
    <li>
      <button
        type='button'
        onClick={() => setSelectedTab('bookable')}
        className={`${selectedTab === 'bookable' ? 'active' : ''}`}
      >
        Purchase bookable
      </button>
    </li>
  </StyledTabsList>
);

export default EventFormNavigation;
